const c = {
  name: "EgyptianPound",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12.1,15.6c-0.2,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.6,0.4L11,17l-0.3,0.8h-0.1L10,16.2
			c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.5,0.5-0.6c0.2-0.2,0.5-0.3,0.7-0.4c0.3-0.1,0.5-0.1,0.8-0.1c1.2,0.1,2.3,0.4,3.4,0.9
			c0.6,0.2,1.2,0.3,1.8,0.3h0.9l-0.6,1c-0.9,0.2-1.9,0.4-2.8,0.7c-2.3,0.9-3.8,2.1-3.8,3.5c0,2.2,2.3,3.4,5.2,3.4
			c0.9,0,1.8,0,2.7-0.2V24c-0.5,0.5-1.1,0.9-1.7,1.2c-0.7,0.1-1.3,0.2-2,0.2c-2.7,0-5-1.3-5-4.2c0-2.5,2.1-4.4,4.7-5l0-0.1
			C14.1,15.8,13.1,15.6,12.1,15.6z"/>
		<path class="st0" d="M16.1,20.6c-0.4-0.4-0.8-0.8-1.2-1.1c-0.3,0.3-0.6,0.7-0.8,1l0.1,0.1c0.4,0.3,0.8,0.6,1.1,1
			C15.6,21.4,15.9,21,16.1,20.6z"/>
		<path class="st0" d="M20.2,18.4c0-0.2,0-0.3,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.3-0.1,0.5-0.1
			c0.2,0,0.3,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.1,0.3,0.1,0.5c0,0.3-0.1,0.7-0.4,0.9
			c-0.2,0.2-0.6,0.4-0.9,0.4s-0.7-0.1-0.9-0.4C20.3,19.1,20.2,18.8,20.2,18.4z"/>
		<path class="st0" d="M25.1,18.5c0-0.3,0.6-0.8,1.7-0.8c0.9,0,1.9,0.1,2.8,0.2c0.2-0.3,0.3-0.7,0.4-1.1c0-0.2,0-0.5-0.1-0.7
			c-0.4-0.8-0.9-1.4-1.6-2c-0.4-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.7,0.2-1,0.4c-0.3,0.3-0.5,0.8-0.6,1.3c0,0.5,0.1,0.9,0.1,1.4
			c-0.4,0.3-0.8,0.8-0.9,1.4c-0.2,0.4-0.3,0.9-0.3,1.4c0,0.4,0.1,0.8,0.2,1.2c0.2,0.6,0.4,1.2,0.6,1.8c0.5,1.5,0.9,2.8,0.9,3.7h0.2
			c0.1-0.5,0.2-1,0.2-1.5c0-0.3,0-0.6-0.1-0.9c-0.2-0.7-0.4-1.4-0.6-2.1C25.5,20.4,25.1,19.2,25.1,18.5z M26.7,15
			c1,0,1.6,0.8,2.2,1.5l-0.1,0.1c-0.5-0.1-1.1-0.2-1.6-0.2c-0.5,0-1,0.1-1.4,0.2c0.1-0.3,0.2-0.7,0.3-1v-0.5
			C26.3,15.1,26.5,15,26.7,15z"/>
		<path class="st0" d="M8.9,3.4C12.2,1.2,16,0,20,0c5.3,0,10.4,2.1,14.1,5.9S40,14.7,40,20c0,4-1.2,7.8-3.4,11.1
			c-2.2,3.3-5.3,5.9-9,7.4C24,40,20,40.4,16.1,39.6c-3.9-0.8-7.4-2.7-10.2-5.5c-2.8-2.8-4.7-6.4-5.5-10.2C-0.4,20,0,16,1.5,12.3
			C3,8.7,5.6,5.6,8.9,3.4z M10,35c3,2,6.4,3,10,3c4.8,0,9.4-1.9,12.7-5.3c3.4-3.4,5.3-8,5.3-12.7c0-3.6-1.1-7-3-10
			c-2-3-4.8-5.3-8.1-6.6C23.6,2,20,1.7,16.5,2.3C13,3,9.8,4.8,7.3,7.3C4.8,9.8,3,13,2.4,16.5C1.7,20,2,23.6,3.4,26.9S7,33,10,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as EgyptianPound
};
